/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tool to remove duplicate lines from text. Dedupe lists, keep order or sort, ignore case, and trim — all in your browser.`)
};

const es_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita para eliminar líneas duplicadas del texto. Desduplicar listas, mantener el orden u ordenar, ignorar mayúsculas y recortar — todo en tu navegador.`)
};

const de_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Tool zum Entfernen doppelter Zeilen aus Text. Listen bereinigen, Reihenfolge beibehalten oder sortieren, Groß-/Kleinschreibung ignorieren und trimmen — alles in Ihrem Browser.`)
};

const nl_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis tool om dubbele regels uit tekst te verwijderen. Dedupliceer lijsten, behoud volgorde of sorteer, negeer hoofdlettergevoeligheid en trim — alles in uw browser.`)
};

const fr_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit pour supprimer les lignes en doublon du texte. Déduplicateur de listes, conservation ou tri de l'ordre, insensibilité à la casse et suppression des espaces — tout dans votre navigateur.`)
};

const it_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito per rimuovere righe duplicate dal testo. Deduplicare elenchi, mantenere l'ordine o ordinare, ignorare maiuscole/minuscole e rimuovere spazi — tutto nel tuo browser.`)
};

const pt_br2_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita para remover linhas duplicadas de texto. Deduque listas, mantenha a ordem ou classifique, ignore maiúsculas e aparar — tudo no seu navegador.`)
};

const pt_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita para remover linhas duplicadas de texto. Elimine duplicatas de listas, mantenha a ordem ou ordene, ignore maiúsculas e apare — tudo no seu navegador.`)
};

const ja_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストから重複行を削除する無料ツール。リストの順序を保持またはアルファベット順にソート、大文字小文字を無視、トリム、空白行を削除します。すべてがブラウザで実行されます。`)
};

const zh_rd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的文本去重工具，可去除重复行。对列表进行去重，保留原始顺序或排序，忽略大小写，并去除首尾空格——全部在你的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_tool_description", locale)
	if (locale === "en") return en_rd_tool_description(inputs)
	if (locale === "es") return es_rd_tool_description(inputs)
	if (locale === "de") return de_rd_tool_description(inputs)
	if (locale === "nl") return nl_rd_tool_description(inputs)
	if (locale === "fr") return fr_rd_tool_description(inputs)
	if (locale === "it") return it_rd_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_rd_tool_description(inputs)
	if (locale === "pt") return pt_rd_tool_description(inputs)
	if (locale === "ja") return ja_rd_tool_description(inputs)
	return zh_rd_tool_description(inputs)
};